"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var style_utils_1 = require("@nef/style-utils");
var styled_components_1 = require("styled-components");
function useColor(color, intensity) {
    var theme = react_1.useContext(styled_components_1.ThemeContext);
    if (theme) {
        return style_utils_1.colorSelector({ theme: theme }, color, intensity);
    }
    if (process.env.NODE_ENV !== "production") {
        console.warn("You are trying to access a theme object from the React context but don't appear to have set up a provider. Please ensure that 'NEFThemeProvider' exists at the top of your application.");
    }
    return "#000";
}
exports.default = useColor;
//# sourceMappingURL=index.js.map